import type { Sku } from "../products/sku";

const isBuyableSkuAvailable = (
    item: Sku, // { availableQuantity: AvailableQuantity; amount: Amount },
    requestedQuantity = 1,
) => {
    if (item.acquire._type !== "BUYABLE")
        throw new Error(
            "cant check other types than buyables; " + item?.acquire?._type,
        );
    if (item.availableQuantity === "INFINITE") return true;
    return item.acquire.amount.value >= requestedQuantity;
};

export { isBuyableSkuAvailable };
